module.exports = __webpack_public_path__ + "img/lender_benefit_branding_mobile.477c2fed.jpg";